import React from "react";
import {connect} from "react-redux";
import styles from "./ProviderWellnessAudit.scss";
import ProviderBase from "components/layout/ProviderBase";
import UnprocessedWellnessVisits from "components/wellness/widgets/UnprocessedWellnessVisits";
import * as SearchTypes from "constants/SearchTypes";
import {PermissionTypes, userHasPermission} from "utils/permissions/rolesPermissions";
import * as UserPermissions from "constants/UserPermissions";
import AccessDenied from "components/common/AccessDenied";
import Button from "components/common/Button";
import {getNodeId} from "utils/AdminData";
import getProviderId from "utils/getProviderId";
import * as ProviderLinks from "utils/ProviderLinks";
import {useHistory} from "react-router";

function ProviderWellnessAudit(props)  {
    const history = useHistory();
    const goToWellnessSettings = () => {
        history.push(ProviderLinks.getLinkLocation("wellness-settings", {
            providerId: props.providerId,
            nodeId: props.nodeId,
            isAdmin: props.isAdmin
        }));
    }

    return (
        <ProviderBase
            location={props.location}
            searchConfig={SearchTypes.WELLNESS_AUDIT}
            clinicId={props.clinicId}
            nodeId={props.nodeId}
            providerId={props.providerId}
            docTitle={"Clinic Wellness Audit"}
        >
            <div className={styles.root}>
                <div className="topLine flex">
                    <h2 className="flex-none">Wellness Audit</h2>
                    <div className="flex-1 flex justify-flex-end">
                        <Button
                            small
                            icon
                            className="margin-right-x-sm"
                            type="primary"
                            onClick={goToWellnessSettings}
                        >
                            <i className="fa fa-reply"/> Back To Clinic Menu
                        </Button>
                    </div>
                </div>
                <div className="flex-1">
                    {!props.canViewWellnessAudit ? (
                        <AccessDenied/>
                    ) : (
                        <UnprocessedWellnessVisits
                            clinicId={props.clinicId}
                        />
                    )}
                </div>
            </div>
        </ProviderBase>
    )
}

export default connect(
    (state, ownProps) => {
        const params = ownProps?.match?.params || {};
        const clinicId = Number(params?.clinicId) || null;
        const userProfile = state.user.userProfile;
        const nodeId = getNodeId(state, ownProps);
        const providerId = getProviderId(params, userProfile);

        // Permissions
        const canViewWellnessAudit = userHasPermission(PermissionTypes.VIEW, UserPermissions.CLINIC_WELLNESS_AUDIT, userProfile);

        return {
            clinicId,
            nodeId,
            providerId,

            // Permissions
            canViewWellnessAudit,
        }
    }
)(ProviderWellnessAudit);
